import React, { useState } from 'react';
import './TrainSmarter.css';
import { Link } from 'react-router-dom'; // ✅ Import Link
import devicering from '../assets/devicering.png';

const slides = [
  {
    image:devicering,
    heading: "Train Smarter",
    description: `Elevate your training with the Timing Gate, the ultimate performance measurement system for athletes and coaches. 
      Designed for speed, agility, reaction time, and jump analysis, our cutting-edge technology delivers millisecond-accurate data to help you train smarter, perform better, and dominate your sport.`,
    buttonText: "View More",
  },
  {
    svg: "/SVG/svg2.svg",
    heading: "Our Application",
    description: `An all in one sports performance and team management platform designed for Athlete ,Trainers and sports associations .From personalized workout tracking to real time device integration and team co-ordination ,Aikyam helps streamline training ,Monitor progress and boost athletic performance with role based access and smart features . `,
    buttonText: "View More",
  },
];

const TrainSmarter = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

 const { image, svg, heading, description, buttonText } = slides[currentIndex];

  return (
    <div className="train-smarter-container">
      {/* Left Navigation */}
      <button className="nav-button left-nav" onClick={prevSlide} aria-label="Previous Slide">
        &lt;
      </button>

      {/* Right Navigation */}
      <button className="nav-button right-nav" onClick={nextSlide} aria-label="Next Slide">
        &gt;
      </button>

<img
  src={image || svg}
  alt={
    heading === "Train Smarter"
      ? "Aikyam Timing Gate sports performance system"
      : "Aikyam Sports App dashboard"
  }
  className={`left-svg-design ${
    svg === "/SVG/svg1.svg" ? "svg1-design" : "svg2-design"
  }`}
/>

      <div className="train-smarter-content">
        <h1 className="content-heading">{heading}</h1>
        <p className="content-description">{description}</p>

        {/* ✅ Conditional Link only for "Train Smarter" slide */}
        {heading === "Train Smarter" ? (
          <Link to="/timing-gates" className="link-no-underline">
            <button className="cta-button">{buttonText}</button>
          </Link>
        ) : (
          <button className="cta-button">{buttonText}</button>
        )}
      </div>

      <div className="diagonal-red-shape"></div>
      <div className="time-gate-text">Time Gate</div>
    </div>
  );
};

export default TrainSmarter;
